import { COLOR_ATHENS_GRAY } from "../constants/styles";

/** Styles to apply a sticky header to `MainLayout` derrived components. */
export const STICKY_HEADER_STYLES = {
    header: {
        background: COLOR_ATHENS_GRAY,
        justifyContent: 'space-between',
        position: 'fixed',
        zIndex: 1,

        width: 'fill-available', // MUI adds vendor prefixes for WebKit and Moz
    },
    underneath: {
        marginTop: '108px', // Arbitrary number to maintain non-sticky look
    },
    withTextAtTheTop: {
        marginTop: '80px', // Arbitrary number to maintain non-sticky look
    },
};